<template>
  <AppDialog
    class="confirm-change-notifications-dialog"
    title="Email notification default"
    append-to-body
    show
    @close="closeDialog"
  >
    <div class="paragraph-text mb-10">
      When provisioning new accounts, the email notification setting will now start in the {{ settingName }} position.
    </div>

    <form
      id="member-change-notifications-form"
      autocomplete="off"
      @submit.prevent="onFormSubmit"
    >
      <div
        id="agree"
        class="form-group mb-10"
      >
        <AppCheckbox v-model="form.agree">
          <span class="is-regular">
            I understand accounts created with this setting {{ settingName }} will
            {{ settingValue ? '' : 'not ' }}receive emails from Hubstaff
          </span>
        </AppCheckbox>
      </div>
    </form>

    <div id="footer">
      <div class="d-flex mt-40">
        <div class="ml-auto">
          <AppButton
            class="mr-15"
            type="default"
            @click="closeDialog"
          >
            Cancel
          </AppButton>

          <button
            class="btn btn-primary"
            type="submit"
            form="member-change-notifications-form"
            :disabled="!form.agree || form.processing"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </AppDialog>
</template>
<script>
import { mapInertiaProps } from '@/utils/inertia';
import { applyTemplate } from '@/utils/url_template';
import { UPDATE_NOTIFICATION_SETTINGS_URL } from '@/app_constants';

export default {
  name: 'MemberProfileFieldDialog',
  components: {},
  props: {
    confirmOverride: {
      type: [String, Boolean],
      default: false,
    },
    needsConfirmChange: {
      type: Number,
      required: true,
    },
    settingValue: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        agree: false,
      }),
    };
  },
  computed: {
    ...mapInertiaProps({
      organization: 'organization',
    }),
    settingName() {
      return this.settingValue ? 'ON' : 'OFF';
    },
  },
  watch: {
    confirmOverride(newVal) {
      if (newVal) {
        this.onFormSubmit();
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    showDeleteProfileDialog(field) {
      this.$emit('show-delete-dialog', field);
    },
    onFormSubmit() {
      const { origin } = window.location;
      const url = new URL(applyTemplate(UPDATE_NOTIFICATION_SETTINGS_URL, { id: this.organization.id }), origin);
      const organizationsUrlString = url.toString();

      this.form.transform((data) => {
        const payload = {
          allow_receiving_emails: this.settingValue,
          update_for_all_users: this.confirmOverride === 'update',
        };

        return { organization: payload };
      });

      const options = {
        onSuccess: () => {
          this.$appMessage(`Email notification default set to "${this.settingValue ? 'OFF' : 'ON'}"`);
          this.closeDialog();
        },
      };

      if (this.needsConfirmChange && !this.confirmOverride) {
        return this.$emit('open-confirm-override-dialog');
      }

      this.form.post(organizationsUrlString, options);
    },
  },
};
</script>
